
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../../modules/general.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoginComponent } from './login.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { environment } from '../../../environments/environment';
import { YubiDialogModule } from '../../dialogs/yubi/yubi.module';
import { YubiDialog } from '../../dialogs/_index';
import { ScrollIntoViewDirective } from '../../directives/scroll-into-view';
import { AutoFocoDirective } from '../../directives/autofocus.directive';
import { FocusDirective } from '../../directives/focus';
import { AngularFireModule } from '@angular/fire/compat';

@NgModule({
    exports: [LoginComponent],
    imports: [
        CommonModule,
        FormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireMessagingModule,
        AngularFireModule.initializeApp(environment.firebase),
        GeneralModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatDialogModule,
        MatButtonModule,
        YubiDialogModule
    ],
    declarations: [LoginComponent,ScrollIntoViewDirective, AutoFocoDirective, FocusDirective],
    providers: [],
    entryComponents: [YubiDialog]
})

export class LoginModule { }